import autocomplete from "@tarekraafat/autocomplete.js";
let search_tags = []

export function makeAutocomplete(selector,destination,searchbar,inline,parentEl) {
    //selector #autocomplete input field
    //destination #search_results result list
    //searchbar #search_bar form
    //inline is inline boolean
    //parent .search-bar selector
    console.log(selector,destination,searchbar)
    let search_config = {
        selector: selector,
        data: {
            src: search_results,
            keys: ["title","tags"]
        },
        cache: false,
        wrapper: true,
        placeHolder: "Atrodi savu materiālu...",
        diacritics: true,
        resultItem: {
            element: (item, data) => {

                if(data.value.tags) {
                    item.innerHTML = '<a href="'+data.value.url+'">'+data.value.title+'</a>';
                } else {
                    item.innerHTML = '<a href="'+data.value.url+'">'+data.match+'</a>';
                }

            },
            highlight: true
        },
        threshold: 1,
        resultsList: {
            tag: "ul",
            id: "autoComplete_list",
            class: "results_list",
            element: (list, data) => {
                const info = document.createElement("li");
                    // if(data.results.length>0){
                    //     console.log('Adding hidden from elemet')
                    //     $("#noResult").addClass('hidden')
                    // }else{
                    //     console.log('Removing hidden from elemet')
                    //     $("#noResult").removeClass('hidden')
                    // }
                    if (data.results.length > 7) {
                        info.innerHTML = '<a class="all-results"><span>Visi rezultāti</span></a>';
                    }
                    // info.addEventListener('click tap',function(){
                    //     console.log('All results')
                    //     $(searchbar).submit()
                    //     return false;
                    // })
                    list.append(info);

            },
            destination: destination,
            maxResults: 8,
        },
        events: {
            input: {
                keydown: (event) => {
                    // if($(selector).val()!=""){
                    //     if($(parentEl+" .cats").hasClass('hide-cats')==false){
                    //         console.log('Removing hidden from key event')
                    //         $(parentEl+" #noResult").removeClass('hidden')
                    //     }else{
                    //         console.log('Adding hidden from key event')
                    //         $(parentEl+" #noResult").addClass('hidden')
                    //     }
                    // }else{
                    //     $(parentEl+" #noResult").addClass('hidden')
                    // }
                },
                // open:(event)=>{
                //     $(selector).removeAttr('hidden')
                // }
            }
        },
    }

    new autocomplete(search_config);
    document.querySelector(selector).addEventListener("results", function (event) {
        console.log('selector results. Adding hide-cats')
        console.log(event.detail)
        if(event.detail.matches.length>0){
            $(parentEl+" .cats").addClass("hide-cats");
            $(parentEl+" #noResult").addClass('hidden')
        }else{
            $(parentEl+" .cats").removeClass("hide-cats");
            $(parentEl+" #noResult").removeClass('hidden')
        }


    });
    document.querySelector(selector).addEventListener("selection", function (event) {
        console.log('selector selection.submiting');
        event.preventDefault();
        $(searchbar).submit()
        return false;


    });
    document.querySelector(selector).addEventListener("focus", function (event) {
        console.log('selector focused. Adding show-but')
        $(searchbar).addClass("show-but");
        // $(".search-bar .cats").addClass("hide-cats");
        if(inline){
            $('.search-page-header').addClass('searchModal')
        }
        if($(selector).val()==""){
            if(inline){
                $(parentEl+" .cats").addClass("show")
                $(".search-bar .cats").removeClass("hide-cats");
            }
        }

    });
    document.querySelector(selector).addEventListener("focusout", function (event) {
        console.log('selector focused out. Hiding buttons if no value present',parentEl)
        if(inline){
            // $(parentEl+" .cats").removeClass("show")
        }
    });
    document.querySelector(selector).addEventListener("open", function (event) {
        console.log('selector opened. Adding hide-cats')
        // $(searchbar).addClass("show-but");
        if(inline){

        }else{
            $(parentEl+ " .cats").addClass("hide-cats");
        }

    });
    // document.querySelector(selector).addEventListener("input", function (event) {
        

    // });
    document.querySelector(selector).addEventListener("close", function (event) {
        console.log('selector closed.')
        if(inline){
            if($(parentEl+" .cats").hasClass("hide-cats")){
                console.log('Cats has hide-cats')
                if($(selector).val()==""){
                    console.log('Input empty')
                    $(parentEl+" .cats").removeClass("hide-cats")
                    $(parentEl + " #autoComplete_list").attr('hidden',"")
                }else{
                    console.log('Input not empty')
                    $(parentEl + " #autoComplete_list").removeAttr('hidden')
                }
                
            }else{
                
            }
        }else{
            
            if($(parentEl+" .cats").hasClass("hide-cats")){
                console.log('Cats has hide-cats')
                if($(selector).val()==""){
                    console.log('Input empty')
                    $(parentEl+" .cats").removeClass("hide-cats")
                    $(parentEl + " #autoComplete_list").attr('hidden',"")
                }else{
                    console.log('Input not empty')
                    $(parentEl + " #autoComplete_list").removeAttr('hidden')
                }
                
                // console.log('Removing hide-cats from close')
                
            }else{
                
            }
            // $(parentEl+" .cats").removeClass("hide-cats");
            if($(selector).val()==""){
                console.log("Input empty removing show-but adding attr hidden")
                $(searchbar).removeClass("show-but");
                $(parentEl + " #autoComplete_list").attr('hidden',"")
                // if($(parentEl+" .cats").hasClass("hide-cats")){
                //     console.log('Adding hidden from close')
                //     $(parentEl+" #noResult").addClass('hidden')
                // }else{
                //     console.log('Removing hidden from close')
                //     $(parentEl+" #noResult").removeClass('hidden')
                // }
            }else{
                // if($(parentEl+" .cats").hasClass("hide-cats")){
                //     $(parentEl+" #noResult").addClass('hidden')
                // }
                
                
                // $(".search-bar .cats").addClass("hide-cats");
            }
        }

        // $(".search-bar .cats").removeClass("hide-cats");
    });


    $("form"+searchbar).on("submit", function () {
        console.log('Submited')
        let me = $(this);
        let data = me.serializeArray();
        let formData = {}

        $.each(data, function () {

            if (this.value) {
                formData[this.name] = this.value;
            }

        });

        formData.search_tags = search_tags

        if(formData.search) {

            if(formData.search_tags) {
                me.find(".tags_").val(JSON.stringify(formData.search_tags))
            }

            return true;
        } else {
            return false;
        }

    });

    $(selector).on("focus", function() {
        console.log('selector closed. adding class show to cats')

        $(this).parent().parent().parent().find(".cats").addClass("show")
    });


    // $('body').on('click', function(e) {
    //     if($(e.target).closest('.search-bar-container').length == 0) {
    //         clearSearch()
    //     }
    // });

    $(".search-bar .search-bar-container form .but").on("click tap", function() {
        let me = $(this)

        if(me.hasClass("clear")) {
            console.log("clear search button")
            if($(parentEl).hasClass('inline')){
                $(selector).val("")
                $(parentEl+" .cats").removeClass("hide-cats");
                $(parentEl+" .cats").removeClass("show")
                me.parent().removeClass("show-but")
                $(parentEl+" #autoComplete_list").attr('hidden',"")
                $(parentEl+" #noResult").addClass('hidden')
            }else{
                $(selector).val("")
                $(parentEl+" .cats").removeClass("hide-cats");
                $(parentEl+" .cats").removeClass("show")
                me.parent().removeClass("show-but")
                $(parentEl+" #autoComplete_list").attr('hidden',"")
                $(parentEl+" #noResult").addClass('hidden')
            }

        }

        if(me.hasClass("submit")) {
            console.log("submit search")
            $(searchbar).submit()
        }

    })
    $(".search-bar ul.results_list li a.all-results").on("click tap", function(event) {
        $(searchbar).submit()
        event.preventDefault();
    })
    $(destination).on('click tap'," ul.results_list li a.all-results",function(event){
        $(searchbar).submit()
        event.preventDefault();
    })

}

$(document).on("click tap",".search-bar .cats .buts .but", function() {
    let me = $(this);
    let id = me.data("id")
    me.toggleClass("selected");

    if(me.hasClass("selected")) {

        if (search_tags.indexOf(id) === -1) {
            search_tags.push(id);
        }

    } else {
        removeItemAll(search_tags,id)
    }

    if(search_tags.length > 0) {
        $(".search-bar a.clear-cats").addClass("show")
    } else {
        $(".search-bar a.clear-cats").removeClass("show")
    }


});

$(document).on("click tap",".search-bar .search-bar-container .cats a.clear-cats", function() {
    let me = $(this)
    me.removeClass("show")
    search_tags = []
    $(".search-bar .cats .buts .but").removeClass("selected")
    // clearSearch()
    return false
})

export function clearSearch() {
    console.log('Clearing search')

    search_tags = []
    // $('#autoComplete_list').prop('hidden')
    $(".search-bar #autoComplete_list").attr('hidden',"")
    $(".search-bar .cats .buts .but").removeClass("selected")
    $(".search-bar .cats").removeClass("show")
    $(".search-bar input").val("")
    $(".search-bar .cats").removeClass("hide-cats");
}


function removeItemAll(arr, value) {
    let i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }
    return arr;
}